import { render, staticRenderFns } from "./TituloComponent.vue?vue&type=template&id=7475c798&"
import script from "./TituloComponent.vue?vue&type=script&lang=js&"
export * from "./TituloComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports